import {copyFilenameToClipboard} from "../utils/manualFinderUtils";
import {matchToOEM} from "../services/matchedPairs/matchToOEM";
import {matchActions} from "../types/common";
import {useRecordEvent} from "aws-rum-react";
import {useTranslation} from "react-i18next";

export const useMatchToOEM = () => {
    const recordEvent = useRecordEvent();
    const {t} = useTranslation();

    const matchOemToSingleClick = async (metadata: any, imageId: string, selectedNameSpace: string) => {
        if (window.confirm(t("MatchFunctionality.MatchConfirmText"))) {
            copyFilenameToClipboard(metadata.FileName, t("CopyToClipboardMessage"))
            recordEvent('MatchSingleToOEM', {'description': 'Match OEM image ' + imageId + ' to single image ' + metadata.FileName});
            await matchToOEM(matchActions.match, metadata.FileName, t, selectedNameSpace, "image_similarity_search/" + imageId + ".png" || "", JSON.stringify(metadata))
        }
    }

    const unmatchOemClick = async (metadata: any, selectedNameSpace: string) => {
        if (window.confirm(t("MatchFunctionality.UnmatchConfirmText"))) {
            recordEvent('UnmatchOEM', {'descriptio`n': 'Unmatch OEM image ' + metadata.FileName});
            await matchToOEM(matchActions.unmatch, metadata.FileName, t, selectedNameSpace)
        }
    }

    return {matchOemToSingleClick, unmatchOemClick}
}